<template>
  <div class="h-fit flex flex-col gap-4">
    <CentralSystemAssignmentMenu :central-system="model" />
  </div>
</template>

<script lang="ts" setup>
import { CentralSystemAssignmentMenu } from '@infuse/cpms/access-management/ui';
import { CentralSystem } from '@infuse/e-connector/central-system/domain';

defineProps<{ model: CentralSystem }>();
</script>
